import React from 'react'
import { rowHeights } from 'components/spreadsheet/types'
import { getRowHeightVariable, getRowHeightClassName } from 'components/spreadsheet/helpers/functions'
import { tv } from 'tailwind-variants'

// The add-row cell in the first data column. It stays horizontally sticky (issue #10461): the
// caller supplies `left` as the sticky offset — the frozen boundary for a non-frozen column, or
// the column's own position when it is frozen. It takes the row's background (bg-inherit), so it
// turns white with the rest of the add-row on hover; the row itself handles the click.
const styles = tv({
  base: 'sticky bg-inherit box-border z-[2] border-l-0',
  variants: {
    topLine: {
      true: 'border-t border-t-divider'
    },
    rootGroup: {
      true: 'border-t border-t-divider'
    },
    greyBackground: {
      true: 'bg-surface-sunken'
    },
    lastFrozen: {
      true: 'shadow-[3px_0_1px_var(--color-divider)]'
    }
  }
})

interface Props {
  loading?: boolean
  rowHeight: rowHeights
  isRootGroup?: boolean
  useGreyBackground?: boolean
  left?: number
  width?: number
  isLastFrozen?: boolean
  /** No top line: the first row under the header, whose border draws it. */
  noTopLine?: boolean
}

const RowNumberCell: React.FC<Props> = ({
  loading,
  rowHeight,
  isRootGroup,
  useGreyBackground,
  left,
  width,
  isLastFrozen,
  noTopLine
}) => {
  return (
    <div
      className={styles({
        rootGroup: isRootGroup && !noTopLine,
        topLine: !noTopLine,
        greyBackground: useGreyBackground,
        lastFrozen: isLastFrozen,
        class: getRowHeightClassName(rowHeight)
      })}
      style={{
        borderTop: noTopLine ? 'none' : `1px solid var(--color-divider)`,
        borderLeft: 'none',
        height: getRowHeightVariable(rowHeight),
        lineHeight: `${getRowHeightVariable(rowHeight)}px`,
        backgroundColor: useGreyBackground ? 'var(--color-surface-sunken)' : 'none',
        width: `${width}px`,
        left: `${left ?? 0}px`
      }}
    >
      {loading ? (
        <span
          className="skeleton-box"
          style={{ width: `${width}px`, height: `${getRowHeightVariable(rowHeight) - 6}px` }}
        />
      ) : null}
    </div>
  )
}

export default RowNumberCell
